module.exports = __webpack_public_path__ + "static/media/mobileScreenshot05.60a780f2.jpg";